module.exports = __webpack_public_path__ + "media/slider/Subscription-5-US-20f6076c.jpg";